import { useCallback, useEffect, useState } from 'react'
import * as S from './styles'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'
import { IconClose, IconLogoWhatsapp } from '@gazin/ecommerce-ui'

const whatsAppStorage = 'whatsAppPopup'

const WhatsAppPopup = () => {
  const [visible, setVisible] = useState(false)
  const [showPopupVisible, setShowPopupVisible] = useState(false)

  const { width } = useWindowDimensions()

  const MIN_DESKTOP_WIDTH = 1024
  const TIME_LIMIT_MINUTES = 10

  const isMobile = width < MIN_DESKTOP_WIDTH

  const handleOnScroll = useCallback(() => {
    setShowPopupVisible(isMobile && window.pageYOffset > 0)
  }, [isMobile])

  const onClose = () => {
    setVisible(false)
    let popupInfo = JSON.parse(localStorage.getItem(whatsAppStorage))

    if (!popupInfo) {
      popupInfo = {
        clickCount: 0,
      }
    }
    popupInfo.clickCount += 1

    if (popupInfo.clickCount > 1) {
      popupInfo.lastClicked = new Date().getTime()
    }

    localStorage.setItem(whatsAppStorage, JSON.stringify(popupInfo))
  }

  const wasTimeLimitReached = useCallback(() => {
    try {
      let popupInfo = JSON.parse(localStorage.getItem(whatsAppStorage))
      if (!popupInfo?.lastClicked) {
        setVisible(true)
        return
      }

      const timeLimit = new Date(popupInfo.lastClicked)
      timeLimit.setMinutes(timeLimit.getMinutes() + TIME_LIMIT_MINUTES)

      if (timeLimit < new Date()) {
        localStorage.setItem(whatsAppStorage, null)
        setVisible(true)
      }
    } catch (error) {
      console.error('Erro ao obter informações do localStorage:', error)
    }
  }, [])

  useEffect(() => {
    wasTimeLimitReached()
  }, [])

  useEffect(() => {
    if (isMobile) {
      window.addEventListener('scroll', handleOnScroll)
    } else {
      setShowPopupVisible(true)
    }

    return () => {
      window.removeEventListener('scroll', handleOnScroll)
    }
  }, [handleOnScroll, isMobile])

  return (
    <>
      {showPopupVisible && (
        <S.PopupContainer visible={visible}>
          <S.CloseButton onClick={onClose} aria-label="Fechar">
            <IconClose width="1.0625rem" height="1.0625rem" />
          </S.CloseButton>
          <S.PopupBox
            target="_blank"
            href="https://api.whatsapp.com/send?phone=5544988488282&text=Ol%C3%A1,%20ser%C3%A1%20um%20prazer%20ajudar,%20envie%20uma%20mensagem%20para%20visualizar%20o%20menu%20de%20atendimento%20e%20escolha%20a%20op%C3%A7%C3%A3o%205(Lojas%20On-line).%20Aguardo%20seu%20contato"
          >
            <S.WhatsAppIcon>
              <IconLogoWhatsapp width="2.5rem" height="2.5rem" />
            </S.WhatsAppIcon>
            <S.TextBox>
              <S.TextTitle>Precisa de ajuda?</S.TextTitle>
              <S.TextSubtitle>Chama no Whatsapp</S.TextSubtitle>
            </S.TextBox>
          </S.PopupBox>
        </S.PopupContainer>
      )}
    </>
  )
}

export default WhatsAppPopup
